import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import styles from './styles.module.less';
import { TargetConnectionList } from '../connection-list/target-connection-list';

/**
 * @returns {JSX.Element}
 */
export const OneSourceSyncConfig = () => {
  return (
    <>
      <Text className={styles.description} textType={TextType.H4} value={messages.setupDescription} />
      <TargetConnectionList />
    </>
  );
};
